<template>
  <MainHeader :isLoginPage="true" />
  <div class="main-layout pt-0">
    <div class="dashboard-layout">
      <div class="content-area init flex flex-1">
        <div
          class="flex-1 bg-white flex-col flex justify-center align-middle pt-5"
        >
          <div class="mb-4">
            <p>
              원활한 웹 사이트 이용을 위해<br />
              간단한 설정을 진행합니다.
            </p>
          </div>
          <div class="laptop:mx-auto mobile:mx-2 w-auto">
            <div
              class="common-card"
              v-bind:class="{
                active: !USER_STATUS.existApiKey || !USER_STATUS.existSecretKey,
              }"
            >
              <div class="flex justify-between items-center mb-2">
                <p class="font-bold">Step1</p>
                <!-- 상태값에 따라 분기처리함 (start)-->
                <span
                  v-if="USER_STATUS.existApiKey && USER_STATUS.existSecretKey"
                  class="text-green-500 text-sm"
                >
                  완료
                </span>
                <span v-else class="text-orange-500 text-sm"> 설정 필요 </span>
                <!-- 상태값에 따라 분기처리함 (end)-->
              </div>
              <p class="text-sm">ApiKey, SecretKey 등록</p>

              <div
                v-if="!USER_STATUS.existApiKey || !USER_STATUS.existSecretKey"
              >
                <div class="mt-2">
                  <label class="text-sm">API Key</label>
                  <input type="text" class="common-input" v-model="apiKey" />
                </div>
                <div class="mt-2">
                  <label class="text-sm">Secret Key</label>
                  <input type="text" class="common-input" v-model="secretKey" />
                </div>
              </div>

              <div class="mt-6">
                <button
                  v-if="!USER_STATUS.existApiKey || !USER_STATUS.existSecretKey"
                  type="button"
                  class="p-2 border border-gray-300 rounded w-full text-sm hover:bg-green-500 hover:border-gray-50 hover:text-white"
                  @click="handleStep1Submit"
                >
                  Submit
                </button>
                <button
                  v-else
                  type="button"
                  class="p-2 border border-gray-100 bg-orange-300 text-white rounded w-full text-sm hover:bg-white hover:border-gray-300 hover:text-black"
                  @click="handleKeyDelete"
                >
                  Edit
                </button>
              </div>
            </div>
            <div
              class="common-card"
              v-bind:class="{
                active:
                  USER_STATUS.existApiKey &&
                  USER_STATUS.existSecretKey &&
                  !USER_STATUS.canTrade,
              }"
            >
              <div class="flex justify-between item-center mb-2">
                <p class="font-bold">Step2</p>
                <span class="text-orange-500 text-sm">확인 필요</span>
              </div>
              <p class="text-sm">거래 가능 여부 확인</p>
              <div class="mt-6">
                <button
                  type="button"
                  class="p-2 border border-gray-300 rounded w-full text-sm hover:bg-green-500 hover:border-gray-50 hover:text-white"
                  @click="handleStep3Submit"
                  v-bind:disabled="step3Loading"
                >
                  <VueSpinner size="20" v-if="step3Loading"></VueSpinner>
                  <span v-else>조회</span>
                </button>
              </div>
            </div>
            <div
              class="common-card"
              v-bind:class="{
                active:
                  USER_STATUS.existApiKey &&
                  USER_STATUS.existSecretKey &&
                  USER_STATUS.canTrade,
              }"
            >
              <div class="flex justify-between items-center mb-2">
                <p class="font-bold">Step3</p>
                <span class="text-orange-500 text-sm">설정 필요</span>
              </div>
              <p class="text-sm">Long, Short 포지션 사용 (Hedge mode)</p>
              <div class="mt-6">
                <button
                  type="button"
                  class="flex justify-center items-center p-2 border border-gray-300 rounded w-full text-sm hover:bg-green-500 hover:border-gray-50 hover:text-white"
                  @click="handleStep2Submit"
                  v-bind:disabled="step2Loading"
                >
                  <VueSpinner size="20" v-if="step2Loading"></VueSpinner>
                  <span v-else>변경</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="help-img flex-2 flex justify-center items-center">
          <div role="tab1" class="flex justify-center items-center w-full">
            <Carousel v-bind="carouselConfig">
              <Slide v-for="slide in items[0].menus" :key="slide">
                <div
                  role="imgAndDesc"
                  class="flex flex-col justify-center items-center"
                >
                  <img class="block mb-2" :src="slide.image" />
                  <span>{{ slide.desc }} </span>
                </div>
              </Slide>
              <template #addons>
                <Navigation />
              </template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "vue3-carousel/dist/carousel.css";
import MainHeader from "@/components/MainHeader.vue";
import { authFetch } from "@/plugins/axiosConfig";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import { VueSpinner } from "vue3-spinners";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { storeName } from "@/global/variable";
import router from "@/routes";

const userStore = "userStore";

export default {
  name: "InitPage",
  components: {
    MainHeader,
    VueSpinner,
    Carousel,
    Slide,
    Navigation,
  },
  setup() {
    const carouselConfig = {
      itemsToShow: 1,
      wrapAround: false,
    };
    return {
      carouselConfig,
    };
  },
  data() {
    return {
      apiKey: "",
      secretKey: "",
      step1Loading: false,
      step2Loading: false,
      step3Loading: false,

      items: [
        {
          title: "api key, secret key 발급 방법",
          menus: [
            {
              image: require("../assets/helpImg/api_0_v1.png"),
              desc: "바이낸스 홈페이지 > Account > API Management 클릭",
            },
            {
              image: require("../assets/helpImg/api_1_v1.png"),
              desc: "상단 'Create API' 클릭",
            },
            {
              image: require("../assets/helpImg/api_2_v1.png"),
              desc: "System generated 선택 후 'NEXT' 클릭",
            },
            {
              image: require("../assets/helpImg/api_3_v1.png"),
              desc: "발급할 키의 라벨 (아무 값이나 입력하셔도 됩니다) 입력 후, 이메일 인증 절차를 거치면 정상적으로 apiKey 및 secretKey 가 발급됩니다.",
            },
            {
              image: require("../assets/helpImg/api_4_v1.png"),
              desc: "Edit restrictions 클릭",
            },
            {
              image: require("../assets/helpImg/api_5_v1.png"),
              desc: "Enable Symbol WhiteList 선택 및 edit 클릭",
            },
            {
              image: require("../assets/helpImg/api_6_v1.png"),
              desc: "이미지에 표시된 코인을 추가 후, Confirm 클릭",
            },
            {
              image: require("../assets/helpImg/api_7_v1.png"),
              desc: "Restric access to trusted IPs only 선택 및 '13.124.123.69' 입력 후 Confirm 클릭",
            },
            {
              image: require("../assets/helpImg/api_8_v1.png"),
              desc: "Enabled Futures 의 버튼이 활성화 되면 선택 후, 상단 'Save' 클릭 후 변경 사항 저장",
            },
          ],
        },
      ],
    };
  },

  mounted() {
    this.$store.dispatch(`${storeName.user}/AC_CHECK_API_SECRET_KEY`);
    // alert("초기 설정이 필요한 유저입니다. 초기 설정 페이지로 이동합니다");
  },
  unmounted() {},
  computed: {
    ...mapGetters(userStore, ["USER_STATUS"]),
  },
  methods: {
    // userStore action 가져오기
    ...mapMutations(userStore, [
      "MU_SAVE_STATUS",
      "MU_UPDATE_DUAL_POSITION",
      "MU_SAVE_STATUS_WITH_LS",
    ]),
    ...mapActions(userStore, [
      "AC_API_SECRET_KEY_SAVE",
      "AC_POST_CONFIG_ACCOUNT",
      "AC_INIT_CHECK",
    ]),

    // step1 유효성 검사
    validStep1() {
      return this.apiKey != "" && this.secretKey != "";
    },

    // step1 저장
    async handleStep1Submit() {
      console.log("click");
      const isValid = this.validStep1();
      if (!isValid) {
        alert("api key 값 혹은 secret key 값을 모두 입력해주시기 바랍니다");
      } else {
        await this.AC_API_SECRET_KEY_SAVE({
          apiKey: this.apiKey,
          secretKey: this.secretKey,
        });
      }
      // todo : apikey , secret key api 전송
    },

    // step1 apikey 및 secret key 초기화
    async handleKeyDelete() {
      if (
        !confirm(
          "등록되어있는 api key 및 secret key 를 초기화 하고 새로 기입하시겠습니까?"
        )
      )
        return false;
    },

    // step2 (hedge mode 변경 요청)
    async handleStep2Submit() {
      this.step2Loading = true;
      try {
        const apiResponse = await authFetch.post("/api/member/position/dual");
        const { code, msg } = apiResponse.data;
        if (code === 200) {
          alert("성공적으로 변경되었습니다");
          this.MU_UPDATE_DUAL_POSITION();

          alert("메인 페이지로 이동합니다.");
          router.push("/");
          // TODO : hedge mode 변경 mutation 처리
        } else if (code === 400) {
          if (msg === "ALREADY_OPEN_ORDER") {
            alert(
              "이미 다른 포지션 모드로 자산이 있습니다. 해당 자산을 청산 후, 다시 시도해주시기 바랍니다"
            );
          } else {
            console.log(code, msg);
          }
        }
        this.step2Loading = false;
      } catch (e) {
        console.log(e);
        this.step2Loading = false;
      }
    },

    // step3 거래 가능 여부 확인
    async handleStep3Submit() {
      this.step3Loading = true;

      try {
        const apiResponse = await authFetch.post("/api/member/config/account");
        if (apiResponse.status === 200) {
          const { canTrade, dualSidePosition, ...etc } = apiResponse.data;
          this.MU_SAVE_STATUS({ canTrade, dualSidePosition, ...etc });
          if (canTrade && dualSidePosition) {
            await this.AC_INIT_CHECK();
          }
          this.step3Loading = false;
        } else {
          alert(
            "계정 정보를 확인하는 도중 오류가 발생했습니다. 잠시 후 다시 시도해주시기 바랍니다."
          );
          this.step3Loading = false;
        }

        // alert("본 서비스를 이용하기 위해 메인 페이지로 이동합니다.");

        // router.push("/");

        // TODO : error 처리
      } catch (e) {
        console.log(e);
        this.step3Loading = false;
      }
    },
  },
};
</script>
<style>
.dashboard-layout {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.content-area {
  display: flex;
  flex: 1; /* 남은 공간을 채움 */
}
.content-area.init {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.bg-gray-100 {
  background-color: #f3f4f6;
}

.tab-indicator {
  cursor: pointer;
}
.tab-indicator::before {
  position: relative;
  /* top: 3pt; Uncomment this to lower the icons as requested in comments*/
  content: "";
  display: inline-block;
  /* By using an em scale, the arrows will size with the font */
  width: 0.4em;
  height: 0.4em;
  border-right: 0.2em solid black;
  border-top: 0.2em solid black;
  transform: rotate(225deg);
  margin-right: 0.5em;
  cursor: pointer;
}

.tab-indicator.tab-right::before {
  transform: rotate(45deg);
  cursor: pointer;
}
</style>
